// import styles from  './app🖌️.scss';

// import('/views👁️👁️👁️/⚪Home/home.js')
// import('/views👁️👁️👁️/🔵Enterprise/enterprise.js')
// import('/views👁️👁️👁️/🟢Ai/ai.js')
// import('/views👁️👁️👁️/📚News/news.js')

import './start🏁🏁🏁/constructor🫀.js';
console.log('%c 💀 CssKiller ','background-color:#111; font-weight:800; color:white; text-transform:uppercase;font-size:30px;');
